import { clsx } from 'clsx';

import { capitalize } from '@mui/material';

import { badgeClasses } from './theme';

import {
  StyledBadge,
  StyledBadgeEndIcon,
  StyledBadgeLabel,
  StyledBadgeStartIcon,
} from './Badge.styled';

import type { BadgeProps } from './types';

const Badge = (props: BadgeProps) => {
  const {
    startIcon,
    endIcon,
    color = 'gray',
    variant = 'filled',
    shape = 'rectangular',
    disabled,
    ref,
  } = props;
  const ownerState = { ...props, color, variant, shape };

  // 동적 클래스만 생성 (고정 클래스는 target으로 처리)
  const getDynamicClasses = () => {
    return {
      root: clsx(
        // badgeClasses.root는 target으로 자동 적용되므로 제외
        variant &&
          color &&
          badgeClasses[`${variant}${capitalize(color)}` as keyof typeof badgeClasses],
        shape === 'circular' && badgeClasses.shapeCircular,
        disabled && badgeClasses.disabled,
        // disabled 클래스는 원본 useUtilityClasses에서 적용되었음 (스타일은 없었지만 클래스는 적용)
      ),
      label: clsx(),
      startIcon: clsx(),
      endIcon: clsx(),
      // label, startIcon, endIcon은 항상 같으므로 동적 클래스 없음
    };
  };

  const dynamicClasses = getDynamicClasses();

  return (
    <StyledBadge
      ref={ref}
      ownerState={ownerState}
      className={clsx(dynamicClasses.root, props.className)}
    >
      {startIcon && (
        <StyledBadgeStartIcon ownerState={ownerState} className={dynamicClasses.startIcon}>
          {startIcon}
        </StyledBadgeStartIcon>
      )}
      <StyledBadgeLabel ownerState={ownerState} className={dynamicClasses.label}>
        {props.label}
      </StyledBadgeLabel>
      {endIcon && (
        <StyledBadgeEndIcon ownerState={ownerState} className={dynamicClasses.endIcon}>
          {endIcon}
        </StyledBadgeEndIcon>
      )}
    </StyledBadge>
  );
};

export default Badge;
